import { Modal } from 'react-bootstrap'
import CheckBoxList from '../../../Components/CheckBoxList'
import { useUser } from '../../../../Providers/UserProvider'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const SelectUserRolesModal = ({ show, onHide }) => {
    const { t } = useTranslation()
    const { userRoles } = useUser()
    const [selectedRoles, setSelectedRoles] = useState([])

    useEffect(() => {
        setSelectedRoles([])
    }, [show])

    return (<Modal size='lg' show={show} onHide={() => onHide(null)} centered>
        <Modal.Header closeButton={true}>
            <Modal.Title>Nadaj uprawnienia konta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="cont profile-details-info">
                <div className="row data-container">
                    <CheckBoxList title={'Poziom uprawnień'} userRoles={userRoles} selectedRoles={selectedRoles} setSelectedRoles={setSelectedRoles} />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <button className='btn-app-primary' onClick={() => onHide(selectedRoles)}>{t("confirm")}</button>
            <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
        </Modal.Footer>
    </Modal>)
}

export default SelectUserRolesModal